<div
    class="report-adjustments-analisysplus-component gap-12"
    fxLayout="column"
    fxFlex
>
    @if (!options.sources?.length || options.sources?.length === 1) {
        <div class="card-container">
            <div fxLayout="column" class="card gap-12">
                <div class="card-header">
                    <p style="margin: 0">Projeção</p>
                    <mat-slide-toggle
                        [hideIcon]="true"
                        [checked]="analysis.projection.active"
                        (click)="onToggleProjection()"
                    ></mat-slide-toggle>
                </div>
                <div class="card-image">
                    <img src="/images/projection.png" alt="Projeção" />
                </div>
                <p class="card-content">
                    Simule os próximos resultados da empresa através do modelo
                    de regressão linear.
                </p>
                @if (analysis.projection.active) {
                    <dsn-select
                        class="full-width"
                        [size]="'medium'"
                        [value]="analysis.projection.value"
                        [placeholder]="'Selecione a projeção'"
                        (handleValueChange)="onSelectProjection($event)"
                    >
                        @for (projection of projections; track $index) {
                            <dsn-option [value]="projection.props._id">{{
                                projection.props.name
                            }}</dsn-option>
                        }
                    </dsn-select>
                }
            </div>
        </div>
        <div class="card-container">
            <div fxLayout="column" class="card gap-12">
                <div class="card-header">
                    <p style="margin: 0">Orçamento</p>
                    <mat-slide-toggle
                        [hideIcon]="true"
                        [checked]="analysis.budget.active"
                        (click)="onToggleBudget()"
                    ></mat-slide-toggle>
                </div>
                <div class="card-image">
                    <img src="/images/budget.png" alt="Orçamento" />
                </div>
                <p class="card-content">
                    Ative o orçamento e identifique oportunidades de crescimento
                </p>
                @if (analysis.budget.active) {
                    <dsn-select
                        class="full-width"
                        [size]="'medium'"
                        [value]="analysis.budget.value"
                        [placeholder]="'Selecione o orçamento'"
                        (handleValueChange)="onSelectBudget($event)"
                    >
                        @for (budget of budgets; track $index) {
                            <dsn-option [value]="budget.props._id">{{
                                budget.props.name
                            }}</dsn-option>
                        }
                    </dsn-select>
                }
            </div>
        </div>
    }
    <div class="card-container">
        <div class="card gap-12">
            <div class="card-header">
                <p style="margin: 0">Objetivo</p>
                <mat-slide-toggle
                    [hideIcon]="true"
                    [checked]="analysis.goals.active"
                    (click)="onToggleGoals()"
                ></mat-slide-toggle>
            </div>
            <div class="card-image">
                <img src="/images/objective.png" alt="Objetivo" />
            </div>
            <p class="card-content">
                Defina e acompanhe objetivos para cada indicador.
            </p>
        </div>
    </div>
</div>
<div class="button-container" fxLayout="column">
    <dsn-button
        label="Aplicar"
        type="primary"
        [size]="'large'"
        (click)="onApply()"
        [disabled]="
            !analysis.projection.active &&
            !analysis.budget.active &&
            !analysis.goals.active
        "
        [width]="'full'"
    ></dsn-button>
    <dsn-button
        iconLeft="fas fa-trash"
        label="Limpar"
        type="secondary"
        [size]="'large'"
        (click)="onReset()"
        [width]="'full'"
    ></dsn-button>
</div>
